/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useEffect } from 'react';
import { Asset, EntryPoint } from '@wit/vtv-x-foundation-lib';
import { useDispatch, useSelector } from 'react-redux';
import { PrivateRoutePath } from 'routes/paths';
import { StoreState } from 'store/store';
import * as MyTV from 'store/ducks/myTv';
import translate from 'services/i18n/translate';
import { SimpleHeader, Spinner } from 'ui/components';
import Overlay from 'ui/components/Hero/Overlay';
import BackgroundOverlay from 'assets/images/background/LandingPage_BackgroundImage.png';
import { useHistoryWithState } from 'hooks/useHistoryWithState';
import Grid from '../../components/Grid';
import { useRouter } from '../../../hooks/useRouter';

export default function GridLevel(): JSX.Element | null {
  const history = useHistoryWithState();
  const router = useRouter();
  const dispatch = useDispatch();

  const assets = useSelector((store: StoreState) => MyTV.Selectors.getContinueWatchingAssets(store));
  const error = useSelector((store: StoreState) => MyTV.Selectors.watchNextError(store));
  useEffect(() => {
    if (error) {
      history.push(PrivateRoutePath.MYTV);
    }
  }, [error, history]);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    dispatch(MyTV.ActionCreators.getContinueWatchingAssets());
  }, [dispatch]);

  if (!assets) {
    return (
      <div className="layout-spinner-container">
        <Spinner isActive />
      </div>
    );
  }

  const onCardClick = (asset: Asset, menuItemId?: number) => {
    router.push({ asset, entryPoint: EntryPoint.WATCH_NEXT, menuItemId });
  };

  const backLabel = translate['entrypoint.wishlist'];
  const backUrl = PrivateRoutePath.MYTV;

  return (
    <div className="ondemand-nextlevel ondemand-grid template-holder back-nav" id="MyTv_watchNextThirdLevel">
      <Overlay backgroundImage={BackgroundOverlay} />

      <SimpleHeader
        subtitle={translate['firstTimeUse.watchNext.label'] || ''}
        backLabel={backLabel}
        backUrl={backUrl}
        hideBackIcon
      />

      <Grid
        railId="watchNextThirdLevel"
        className="no-background"
        assets={assets}
        menuItemId={-1}
        onCardClick={onCardClick}
      />
      <div className="load-more-btn-container margin-top-20 margin-bottom-66">
        {!assets ? (
          <div className="layout-spinner-container">
            <Spinner isActive />
          </div>
        ) : null}
      </div>
    </div>
  );
}
